export const AppStoreUrl = "https://apps.apple.com/us/developer/daksha-patidar/id833828385";
export const PlayStoreUrl = "https://play.google.com/store/apps/dev?id=7639755402933353130";